/* eslint-disable react/require-default-props */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Popup, Form, Input } from 'semantic-ui-react';

//import getUnhandledProps from '../lib/getUnhandledProps';

const popupStyle = {
  padding: '0',
};

function InputView(props) {
  const {
    popupPosition,
    inline,
    value,
    closeOnMouseLeave,
    onChange,
    inlineLabel,
    popupIsClosed,
    onPopupUnmount,
    className,
    //closable,
    //name,
    placeholder,
    disabled
  } = props;
  //const rest = getUnhandledProps(InputView, props);

  const inputElement = (
    <Form>
      <Input
        //{...rest}
        className={className}
        value={value}
        inline={inlineLabel}
        onChange={onChange}
        disabled={disabled}
        icon="calendar"
        iconPosition="left"
        placeholder={placeholder}
      />
    </Form>
  );

  if (inline) return props.children;
  return (
    <Popup
      disabled={disabled}
      position={popupPosition}
      open={popupIsClosed ? false : undefined}
      trigger={inputElement}
      hoverable={closeOnMouseLeave}
      flowing
      onUnmount={onPopupUnmount}
      style={popupStyle}
      hideOnScroll
      on="click"
    >
      { props.children }
    </Popup>
  );
}

InputView.propTypes = {
  /** Whether to display inline picker or picker inside a popup. */
  inline: PropTypes.bool,
  /** Where to display popup. */
  popupPosition: PropTypes.string,
  /** Currently selected value. */
  value: PropTypes.string,
  /** Whether to close a popup when cursor leaves it. */
  closeOnMouseLeave: PropTypes.bool,
  /** Called after input field value has changed. */
  onChange: PropTypes.func,
  /** Picker. */
  children: PropTypes.node,
  /** A field can have its label next to instead of above it. */
  inlineLabel: PropTypes.bool,
  /** Whether popup is closed. */
  popupIsClosed: PropTypes.bool,
  /** Called when popup is forsed to close. */
  onPopupUnmount: PropTypes.func,
};

InputView.defaultProps = {
  inline: false,
  closeOnMouseLeave: true
};

export default InputView;
